import { useParams } from 'react-router-dom'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useEffect } from 'react'
import logoCareme from '../../assets/caremePlusLogo.svg'
import style from '../layout/Main.module.css'
import { AppointmentDetail as AD } from 'features/appointment-detail'

type AppointmentDetailProps = {
  title?: string
}

export function AppointmentDetail({ title }: AppointmentDetailProps) {
  const { id } = useParams()
  const { setTitle } = useTitleHeaderContext()

  useEffect(() => {
    setTitle(title || '')
  }, [title, setTitle])

  return (
    <>
      <AD appointmentId={id ?? ''} />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
